module.exports = __webpack_public_path__ + "img/pencil.1a25b7a7.svg";